import { render, staticRenderFns } from "./CreateSusteams.vue?vue&type=template&id=3e6c43c2&"
import script from "./CreateSusteams.vue?vue&type=script&lang=js&"
export * from "./CreateSusteams.vue?vue&type=script&lang=js&"
import style0 from "./CreateSusteams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports